<template>
  <div class="content-block content-block--separated property-additional-resources">
    <h2 class="mb-4">
      Resources
    </h2>
    <p>{{ description }}</p>
    <v-list>
      <v-list-item
        v-for="resource in resources"
        :key="resource.id"
      >
        <a
          :href="resource.resource_file"
          target="_blank"
          class="text-center property-additional-resources__link"
        >
          {{ resource.name }}
        </a>
      </v-list-item>
    </v-list>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator'
import { Resource } from '../../middleware/Resource'

@Component({
  components: {
  },
})
export default class PropertyAdditionalResources extends Vue {
  @Prop({ type: Array }) resources: Resource[]
  @Prop({ type: String }) description: string
}
</script>

<style lang='scss'>
.property-additional-resources {
  &__link {
    text-decoration: none;
  }
}
</style>
